module.exports = __webpack_public_path__ + "img/treasury3.9c918db6.png";